module.exports = {"511111100":"沙湾镇","511111101":"嘉农镇","511111102":"太平镇","511111103":"福禄镇","511111104":"牛石镇","511111105":"龚嘴镇","511111106":"葫芦镇","511111107":"踏水镇","511111200":"谭坝乡","511111201":"轸溪乡","511111202":"范店乡","511111203":"铜茨乡","511111204":"碧山乡","511111400":"沫江"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511111.json
// module id = 2330
// module chunks = 0